import { forwardRef, memo } from 'react';
import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useRenderColumns } from '../../columns';
import { SnapCarousel } from '../../main';
import { SnapCarouselWrapper, Table, tableMixin } from '../components';
import { useLayout } from '../layout-context';

export const LayoutTable = memo(
  forwardRef<HTMLDivElement, unknown>((_, ref) => {
    const {
      breakpoints: { overflows, isSmallBreakpoint, isMediumBreakpoint },
      rowsCount
    } = useLayout();
    const columns = useRenderColumns();

    if (overflows) {
      return (
        <SnapCarouselWrapper ref={ref} component="layout-classic-table">
          <Container>
            <StyledSnapCarousel
              $rowsCount={rowsCount}
              $isSmallBreakpoint={isSmallBreakpoint}
              $isMediumBreakpoint={isMediumBreakpoint}
            >
              {columns}
            </StyledSnapCarousel>
          </Container>
        </SnapCarouselWrapper>
      );
    }

    return (
      <Table ref={ref} component="layout-classic-table">
        {columns}
      </Table>
    );
  })
);

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'layout-classic-table',
    element: 'container'
  })
})`
  ${tableMixin}
`;

const StyledSnapCarousel = styled(SnapCarousel).attrs<{
  $rowsCount: number;
  $isSmallBreakpoint: boolean;
  $isMediumBreakpoint: boolean;
}>({
  columnsGap: 0,
  className: createReadableClass({
    component: 'layout-classic-table',
    element: 'snap-carousel'
  })
})`
  display: grid;
  margin: 0 auto;
  grid-auto-columns: ${({ $isSmallBreakpoint, $isMediumBreakpoint }) => {
    if ($isSmallBreakpoint) {
      return 90;
    }

    if ($isMediumBreakpoint) {
      return 40;
    }

    return 100 / 3;
  }}%;

  & > div {
    display: grid;
    grid-template-rows: subgrid;
    grid-template-columns: subgrid;
    grid-row: ${({ $rowsCount }) => `1 / ${$rowsCount + 1}`};
  }
`;
